import { ArrowLeft, Home, ShieldX } from 'lucide-react';
import { motion } from 'motion/react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { useRouter } from '@/hooks/use-router';

export function ForbiddenPage() {
  const router = useRouter();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6 py-10">
      <motion.div
        initial={{ opacity: 0, scale: 0.96, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        className="w-full max-w-xl"
      >
        <Card className="relative overflow-hidden border-border/50 bg-gradient-to-br from-background to-muted/40 shadow-2xl">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(239,68,68,0.12),transparent_35%)]" />

          <CardContent className="relative flex flex-col items-center px-8 py-14 text-center">
            <motion.div
              initial={{ rotate: -10, scale: 0.8 }}
              animate={{ rotate: 0, scale: 1 }}
              transition={{ type: 'spring', stiffness: 120 }}
              className="mb-6 flex h-24 w-24 items-center justify-center rounded-full border border-red-500/20 bg-red-500/10"
            >
              <ShieldX className="h-12 w-12 text-red-500" />
            </motion.div>

            <span className="mb-2 rounded-full border border-red-500/20 bg-red-500/10 px-4 py-1 text-sm font-medium text-red-500">
              Erro 403
            </span>

            <h1 className="mb-3 text-4xl font-bold tracking-tight">Acesso negado</h1>

            <p className="mb-8 max-w-md text-muted-foreground">
              Você não possui permissão para acessar esta página. Caso ache que isso é um
              erro, entre em contato com um administrador.
            </p>

            <div className="flex flex-col gap-3 sm:flex-row">
              <Button size="lg" onClick={() => router.push('/')} className="gap-2">
                <Home className="h-4 w-4" />
                Voltar para o início
              </Button>

              <Button
                size="lg"
                variant="outline"
                onClick={() => window.history.back()}
                className="gap-2"
              >
                <ArrowLeft className="h-4 w-4" />
                Página anterior
              </Button>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
}
